import React from 'react'
import {
  Show,
  TextField,
  DateField,
  ArrayField,
  Datagrid,
  BooleanField,
} from 'react-admin';
import { Box } from '@mui/material';
import NestedReferenceField from '../../components/NestedReferenceField';
import SelfLinkField from '../../components/SelfLinkField';

const OrganisationShow = (props) => {
  return (
    <Show {...props} title="Organisation Details">
      <Box display="flex" flexDirection="column" gap={2} padding={2}>
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <TextField source="email_domain" label="Email domain" />
        <TextField source="description" />
        <TextField source="join_policy" label="Join policy" />
        <BooleanField source="must_be_admin_to_create_cases" label="Admin required to create cases" />
        <DateField source="creation_date" label="Created at" showTime />
        <DateField source="update_date" label="Updated at" showTime />

        <ArrayField source="user_in_organisations">
          <Datagrid bulkActionButtons={false}>
            <NestedReferenceField source="user" labelField="email" resource="users" label="User" />
            <TextField source="type" label="Role" />
            <BooleanField source="accepted" />
          </Datagrid>
        </ArrayField>

        <ArrayField source="teams">
          <Datagrid bulkActionButtons={false}>
            <SelfLinkField source="name" resource="teams" label="Team" />
            <TextField source="confidentiality_policy" label="Confidentiality" />
          </Datagrid>
        </ArrayField>
      </Box>
    </Show>
  );
};

export default OrganisationShow;
